module.exports = __webpack_public_path__ + "img/csca-nav-icon.18401e7f.svg";